import { useEffect } from 'react'
import { useOptionalActivityPlanDetailHeader } from '../activity-plan-detail-header-context'

const InlineActionsPortal = ({ children }) => children

const useRegisterActivityPlanDetailHeader = ({
  title,
  subtitle,
  inlineActions = false,
}) => {
  const context = useOptionalActivityPlanDetailHeader()
  const HeaderActionsPortal =
    context?.HeaderActionsPortal || InlineActionsPortal
  const renderActionsInline = inlineActions || !context

  useEffect(() => {
    if (!context) {
      return undefined
    }

    context.setDetailTitle(title || null)
    context.setDetailSubtitle(subtitle || null)

    return () => {
      context.clearDetailHeader()
    }
  }, [context, title, subtitle])

  return { HeaderActionsPortal, renderActionsInline }
}

export default useRegisterActivityPlanDetailHeader
